import app from './app.ts';
import { FMessaging } from '~common/firebase/messaging.ts';

export const kupMessaging = FMessaging.getInstance(app, 'kup');
export default kupMessaging;
